import create from 'zustand'
import { CancelationReasonStore } from './types'
import { ICancelationReason } from '@/modules/MyCalls/types'

export const useCancelationReasonStore = create<CancelationReasonStore>()(
  set => {
    return {
      cancelationReasons: null,

      setCancelationReasons: (cancelationReasons: ICancelationReason[]) => {
        set({ cancelationReasons })
      },
    }
  },
)
